export const UserActionTypes = {
    USER_DATA_FIRST: '@@auth/USER_DATA_FIRST',
    USER_DATA_LOADING: '@@auth/USER_DATA_LOADING',
    USER_DATA_SUCCESS: '@@auth/USER_DATA_SUCCESS',
    USER_DATA_ERROR: '@@auth/USER_DATA_ERROR',

    CREATE_USER_DATA_FIRST: '@@auth/CREATE_USER_DATA_FIRST',
    CREATE_USER_DATA_LOADING: '@@auth/CREATE_USER_DATA_LOADING',
    CREATE_USER_DATA_SUCCESS: '@@auth/CREATE_USER_DATA_SUCCESS',
    CREATE_USER_DATA_ERROR: '@@auth/CREATE_USER_DATA_ERROR',

    UPDATE_USER_DATA_FIRST: '@@auth/UPDATE_USER_DATA_FIRST',
    UPDATE_USER_DATA_LOADING: '@@auth/UPDATE_USER_DATA_LOADING',
    UPDATE_USER_DATA_SUCCESS: '@@auth/UPDATE_USER_DATA_SUCCESS',
    UPDATE_USER_DATA_RESET: '@@auth/UPDATE_USER_DATA_RESET',
    UPDATE_USER_DATA_ERROR: '@@auth/UPDATE_USER_DATA_ERROR',

    DELETE_USER_DATA_FIRST: '@@auth/DELETE_USER_DATA_FIRST',
    DELETE_USER_DATA_LOADING: '@@auth/DELETE_USER_DATA_LOADING',
    DELETE_USER_DATA_SUCCESS: '@@auth/DELETE_USER_DATA_SUCCESS',
    DELETE_USER_DATA_RESET: '@@auth/DELETE_USER_DATA_RESET',
    DELETE_USER_DATA_ERROR: '@@auth/DELETE_USER_DATA_ERROR',


    STATE_EMPTY_FIRST: '@@auth/STATE_EMPTY_FIRST',

};
